<template>
  <div class="fill-height">
    <v-navigation-drawer  v-model="drawer" app clipped v-if="loggedIn">
      <v-list nav dense>
        <v-list-item link   :to="{name: 'adform'}"  :class="'/adform' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
            <v-icon>mdi-alpha-a-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Add New Ad.</v-list-item-title>
        </v-list-item>
        <v-list-item link   :to="{name: 'studio'}"  :class="'/studio' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
            <v-icon>mdi-alpha-a-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ad Design Studio</v-list-item-title>
        </v-list-item>
        
         <v-list-item link :to="{name: 'home'}" :class="'/' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
            <v-icon>mdi-desktop-mac-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
        <v-list-item link :to="{name: 'adlist'}">
          <v-list-item-icon>
            <v-icon>mdi-alpha-a-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ad. List</v-list-item-title>
        </v-list-item>
        <!--
           <v-list-item link :to="{name: 'topup'}"  :class="'/topup' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
            <v-icon >mdi-credit-card-plus-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>DamnN Bank </v-list-item-title>
        </v-list-item>
        
        <v-list-item link :to="{name: 'faqs'}"  :class="'/faqs' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
             <v-icon >mdi-account-question-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>FAQ </v-list-item-title>
        </v-list-item>
        -->
        <v-list-item link :to="{name: 'transactions'}"  :class="'/transactions' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
             <v-icon >mdi-ballot-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Transaction </v-list-item-title>
        </v-list-item>
        <v-list-item link :to="{name: 'refund'}"  :class="'/refund' === $route.path ? 'highlighted' : ''">
          <v-list-item-icon>
             <v-icon >mdi-cash-refund</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Refund </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar v-if="loggedIn" app clipped-left dark >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="loggedIn" />
      <v-img :src="logo" v-if="loggedIn" style="background-size:contain !important;max-width:170px;" aspect-ratio="1.5" class="logo" ></v-img> 
       <showbalance></showbalance>
     </v-app-bar>
    <v-content class="fill-height" dark>
      <router-view />
    </v-content>
  </div>
</template>


<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    name() {
      return this.$store.getters.name;
    },
    email() {
      return this.$store.getters.email;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  data() {
    return {
      drawer: null,
      logo: require("@/assets/damnnlogo3.png")
    };
  },
  created() {
    this.$vuetify.theme.dark = false;
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    getUserData() {
      this.$store.dispatch("retrieveUserDetails");
    }
  }
};
</script>
<style>
.v-image__image--cover{background-size: contain !important;}
</style>
<style scoped>
.highlighted{background-color: #c9c9c9;}  
.v-btn {
  margin-left: 10px;
}
.name-title {
  text-transform: capitalize;
}
.logoold {
    width: 270px;
    height: 32px;
    margin: 5px 0px 0px 8px;
    text-indent: -1000px;
}
.logo {
    height: 100%;
    margin-right: 10px;
}
</style>
